/* Owns only this story's offer. The shared cart owns adds, checkout and cart events. */
(() => {
  const root = document.querySelector('[data-vsa-story]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const q = selector => root.querySelector(selector);
  const config = JSON.parse(q('[data-vsa-config]').textContent);
  const form = q('#mp-form'), atc = q('[data-vsa-atc]'), status = q('#mp-status');
  const sticky = q('.vsa-sticky'), action = q('[data-vsa-sticky]');
  const stickyTitle = q('.vsa-sticky-title'), stickyDetail = q('.vsa-sticky-detail');
  const stickyError = q('.vsa-sticky-error'), reveal = q('#vsa-reveal');
  const progress = q('.vsa-progress');
  let busy = false, offerSeen = false, frame = 0;
  let cart = window.VyelleMenopauseCart?.state || { itemCount: 0 };
  const money = cents => new Intl.NumberFormat('en-US', {
    style: 'currency', currency: config.currency || 'USD',
    minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
  }).format(cents / 100);
  const selection = () => {
    const choice = q('[name="vsa_choice"]:checked')?.value || 'one';
    const key = choice === 'one' ? 'once' : 'three';
    return { ...config[key], key, jars: choice === 'three' ? 3 : 1 };
  };
  function setHeight() {
    root.style.setProperty('--vsa-sticky-height', sticky.hidden ? '0px' : `${sticky.offsetHeight}px`);
    document.documentElement.style.setProperty('--vsa-sticky-height', sticky.hidden ? '0px' : `${sticky.offsetHeight}px`);
  }
  function updateSticky() {
    const selected = selection(), box = form.getBoundingClientRect();
    const button = atc.getBoundingClientRect();
    const hasCart = cart.itemCount > 0;
    const previewHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mp-preview-bottom')) || 0;
    const viewport = window.innerHeight - previewHeight;
    const buttonVisible = button.top >= 85 && button.bottom < viewport;
    if (box.top < viewport && box.bottom > 85) offerSeen = true;
    const revealed = reveal.getBoundingClientRect().top < viewport * .75;
    sticky.hidden = (!revealed && !hasCart) || (buttonVisible && !hasCart);
    if (hasCart) {
      stickyTitle.textContent = `Your cart · ${money(cart.totalPrice || 0)}`;
      stickyDetail.textContent = 'Review your order and checkout';
      action.textContent = 'View cart';
    } else if (!offerSeen) {
      stickyTitle.textContent = 'Daily Renewal';
      stickyDetail.textContent = 'One-time orders · No subscription';
      action.textContent = 'See options';
    } else {
      stickyTitle.textContent = `${selected.jars} ${selected.jars === 1 ? 'jar' : 'jars'} · ${money(selected.price)}`;
      stickyDetail.textContent = selected.jars === 1 ? 'One-time · $5 US shipping' : 'One-time · Free US shipping';
      action.textContent = 'Add to cart';
    }
    action.disabled = busy || (!hasCart && offerSeen && !selected.available);
    action.setAttribute('aria-busy', String(busy));
    setHeight();
  }
  function update() {
    const selected = selection(), one = config.once;
    q('[data-vsa-one-price]').textContent = money(one.price);
    // Offer selection remains usable while draft checkout is guarded.
    root.querySelectorAll('[name="vsa_choice"]').forEach(input => { input.disabled = false; });
    form.elements.id.value = selected.id || '';
    const savings = config.once.price * selected.jars - selected.price;
    q('[data-vsa-saving]').textContent = savings > 0
      ? `Save ${money(savings)} versus ${selected.jars === 1 ? 'one-time' : selected.jars + ' single jars'}`
      : 'One jar. One payment.';
    q('[data-vsa-unit]').textContent = `${money(Math.round(selected.price / (selected.jars * 30)))} per serving`;
    q('[data-vsa-billing]').textContent = `${money(selected.price)}${selected.jars === 1 ? ' + $5 US shipping' : ' with free US shipping'}, paid once for ${selected.jars} ${selected.jars === 1 ? 'jar' : 'jars'}. No subscription. Applicable tax calculated at checkout.`;
    atc.disabled = busy || !selected.available || !selected.id;
    atc.setAttribute('aria-busy', String(busy));
    atc.textContent = 'Add to cart';
    updateSticky();
  }
  async function add() {
    const selected = selection();
    if (busy || !selected.available) return;
    busy = true;
    status.textContent = 'Adding to your cart…';
    stickyError.textContent = '';
    update();
    try {
      if (!window.VyelleMenopauseCart) throw new Error('Your cart is still loading. Please try again.');
      await window.VyelleMenopauseCart.add(selected.id, null);
      status.textContent = 'Added to your cart.';
    } catch (error) {
      status.textContent = error.message || 'We could not add your order. Please try again.';
      stickyError.textContent = status.textContent;
    } finally { busy = false; update(); }
  }
  form.addEventListener('submit', event => { event.preventDefault(); add(); });
  form.addEventListener('change', event => {
    if (!event.target.matches('[name="vsa_choice"]')) return;
    status.textContent = ''; stickyError.textContent = ''; update();
  });
  action.addEventListener('click', () => {
    if (cart.itemCount > 0) { window.VyelleMenopauseCart?.open(); return; }
    if (offerSeen) { add(); return; }
    form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  });
  document.addEventListener('vy:cart-state', event => {
    cart = event.detail;
    q('[data-vsa-cart-count]').textContent = cart.itemCount ? ` (${cart.itemCount})` : '';
    updateSticky();
  });
  function onScroll() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const distance = document.documentElement.scrollHeight - innerHeight;
      progress.style.width = `${distance > 0 ? Math.min(100, Math.max(0, scrollY / distance * 100)) : 0}%`;
      updateSticky();
    });
  }
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(sticky);
  const bindPreview = () => {
    const bar = document.getElementById('PBarNextFrameWrapper');
    if (!bar || bar.dataset.vsaReady) return;
    bar.dataset.vsaReady = 'true';
    const sync = () => {
      document.documentElement.style.setProperty('--mp-preview-bottom', `${bar.isConnected ? bar.getBoundingClientRect().height : 0}px`);
      onScroll();
    };
    sync();
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(bar);
  };
  bindPreview();
  new MutationObserver(bindPreview).observe(document.body, { childList: true });
  update(); onScroll();
})();
